export enum SequenceStatusEnum {
  Running = 'RUNNING',
  OnHold = 'ON_HOLD',
}
